import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "../services/axios";
import useAuth from "../hooks/useAuth";

import { convertLanguageToField } from "../utils/functions";

export function useCategories() {
  const { i18n } = useTranslation();
  const [categories, setCategories] = useState([]);
  const [r, setReload] = useState(0);
  const { user } = useAuth();

  const desafios_picantes = [
    { index: 1, image: "taca" },
    { index: 2, image: "morango" },
    { index: 3, image: "boca" },
    { index: 4, image: "mao_cu" },
    { index: 5, image: "camisinha" },
  ];

  const reload = () => {
    setReload((prev) => prev + 1);
  };

  useEffect(() => {
    axios
      .get(`/categories/getAllCategorieWeb?id_usuario=${user.id_usuario}`)
      .then((response) => {
        const { data } = response;
        const field = convertLanguageToField(i18n.language, "title");

        const finalCategorias = data.map((item) => {
          let items = desafios_picantes.find((cat) => cat.index === item.id);
          if (!items) {
            items = {
              image: "default",
              label: item.title,
              is_free: 0,
              custom: true,
            };
          }
          return { ...item, label: item[field], ...items };
        });

        setCategories(finalCategorias);
      });
  }, [i18n.language, user, r]);

  return [categories, reload];
}
